<template>
  <div>
    <page-header>
      <div class="row">
        <div class="col-xs-12 text-center">
          <img class="_margin-bottom-20" src="../../assets/results-page/ev.png" style="width: 100%; max-width: 500px" />
          <h1 class="text-center center-block _margin-bottom-30" style="max-width: 700px; margin: auto">
            Discover How Much You Can Save by Switching to an EV!
          </h1>

          <uiv-btn class="_margin-top-10" type="primary"
            @click="onExplore('evCompare', 'Compare EV Charging vs. Fuel Costs')" style="margin-right: 20px">
            Compare EV Charging vs. Fuel Costs
          </uiv-btn>
          <uiv-btn class="_margin-top-10" type="primary" @click="onExplore('evOnly', 'See the Best EV Energy Deal')">
            See the Best EV Energy Deal
          </uiv-btn>
        </div>
      </div>
    </page-header>

    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <p style="max-width: none">
            Switching to an electric vehicle (EV) is more than just an
            eco-friendly choice - it's a smart financial decision. Our tool
            helps you compare your current fuel costs vs. EV charging costs,
            giving you a clear breakdown of potential savings and environmental
            benefits.
          </p>
        </div>
      </div>
    </div>

    <div class="page-section">
      <div class="container">
        <div class="row">
          <div class="col-md-5">
            <img src="../../assets/home/person-2.png" />
            <div class="_margin-bottom-20 visible-xs visible-sm"></div>
          </div>

          <div class="col-md-7">
            <h5 class="_margin-bottom-10">
              Why switching to an EV makes sense
            </h5>
            <ul>
              <li>
                Reduce your carbon footprint by eliminating CO₂ emissions.
              </li>
              <li>
                EVs are far more efficient, costing just a fraction per mile
                compared to traditional fuel.
              </li>
              <li>
                EVs convert more energy into actual motion, reducing waste and
                increasing sustainability.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="container _margin-top-10">
      <div class="row">
        <div class="col-md-7">
          <h5>What we'll show you</h5>

          <ul class="bullets">
            <li><span>1</span> EV Charging Costs Breakdown</li>
            <li><span>2</span> Fuel vs. Charging Cost Comparison</li>
            <li><span>3</span> Carbon Footprint Reduction</li>
            <li><span>4</span> Best Energy Tariff Recommendation</li>
          </ul>
        </div>

        <div class="col-md-5">
          <img class="center-block img-responsive" src="../../assets/home/ev-charging.png" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-8">
          <p>
            Enter your postcode and see how much you could save by switching
            from petrol or diesel to electric.
          </p>
        </div>

        <div class="col-md-4">
          <uiv-btn class="_margin-top-10 _margin-bottom-20" block type="primary"
            @click="onExplore('evCompare', 'Compare EV Charging vs. Fuel Costs')">
            Compare EV Charging vs. Fuel Costs
          </uiv-btn>
          <uiv-btn block type="primary" @click="onExplore('evOnly', 'See the Best EV Energy Deal')">
            See the Best EV Energy Deal
          </uiv-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import YourHome from '@/components/current-tariff/YourHome';
import PageHeader from '@/components/page-header/PageHeader';

import { mapState } from 'vuex';

export default {
  name: 'SolarBattery',
  computed: {
    ...mapState({
      quote: ({ session }) => session.quote_journey_session
    })
  },
  mounted() {
    this.$store.dispatch('tracing/addAction', {
      name: 'Action',
      value: 'Viewed'
    });
    this.$store.dispatch('tracing/saveActions');
  },
  methods: {
    onExplore(type, buttonName) {
      if (type == 'all') {
        this.quote.evCompare = true;
        this.quote.evOnly = false;
        this.quote.ashp = true;
        this.quote.solar = true;
      } else {
        this.quote.evCompare = false;
        this.quote.evOnly = false;
        this.quote.ashp = false;
        this.quote.solar = false;
        this.quote[type] = true;
      }

      this.$store.dispatch('session/setItem', {
        key: 'quote_journey_session',
        value: this.quote
      });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: buttonName });
      this.$store.dispatch('tracing/saveActions');
      this.$router.push({ name: 'currentTariff' });
    }
  },
  components: {
    YourHome,
    PageHeader
  }
};
</script>

<style lang="scss" scoped>
.page-section {
  background-color: rgba(124, 3, 3, 0.2);
  padding-top: 25px;
  padding-bottom: 25px;

  ul {
    padding-left: 0;
    list-style: none;

    li {
      padding: 10px;
      background-color: #fff;
      margin-bottom: 10px;
      font-size: 20px;
      border-radius: 17px;
    }
  }
}

.bullets {
  padding-left: 0;
  list-style: none;

  li {
    position: relative;
    padding: 10px 10px 10px 70px;
    background-color: #fff;
    margin-bottom: 10px;
    font-size: 24px;
    border-radius: 17px;
    border: 4px solid rgba(16, 58, 88, 1);
    max-width: 450px;

    &:nth-child(2) {
      margin-left: 50px;
    }

    &:nth-child(4) {
      margin-left: 50px;
    }

    span {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translate(0, -50%);
      font-size: 50px;
      font-weight: bold;
      color: rgba(255, 0, 0, 1);
      padding: 10px;
      width: 70px;
      text-align: center;
    }

    @media (max-width: 767px) {
      &:nth-child(2) {
        margin-left: 0px;
      }

      &:nth-child(4) {
        margin-left: 0px;
      }
    }
  }
}
</style>
